import React from 'react';

// Underlined tabs of the Activité page header — the reference look for every tab
// bar of the backoffice: teal label + 2px teal underline on the active tab, grey
// with a grey underline on hover for the others. Icons are hidden on phones.

export const tabClass = (active) =>
    `px-3 sm:px-4 py-2 flex items-center gap-2 transition-all whitespace-nowrap flex-shrink-0 border-b-2 text-sm sm:text-base ${
        active
            ? 'text-primary border-primary'
            : 'text-gray-600 dark:text-gray-400 border-transparent hover:text-gray-700 dark:hover:text-gray-300 hover:border-gray-300 dark:hover:border-gray-600'
    }`;

export const tabIconClass = 'hidden sm:block w-[22px] h-[22px] flex-shrink-0';

// tabs: [{key, label, Icon?, badge?}]
const TabBar = ({tabs, active, onChange, className = ''}) => (
    <div role="tablist" className={`flex overflow-x-auto no-scrollbar w-full md:justify-center ${className}`}>
        {tabs.map(({key, label, Icon, badge}) => (
            <button
                key={key}
                type="button"
                role="tab"
                aria-selected={active === key}
                onClick={() => onChange(key)}
                className={tabClass(active === key)}
            >
                {Icon && <Icon className={tabIconClass} strokeWidth={2}/>}
                <span>{label}</span>
                {badge !== undefined && badge !== null && (
                    <span className={`px-1.5 py-0.5 text-xs rounded-full ${
                        active === key ? 'bg-primary/10 text-primary' : 'bg-gray-100 dark:bg-gray-700 text-gray-500 dark:text-gray-400'
                    }`}>
                        {badge}
                    </span>
                )}
            </button>
        ))}
    </div>
);

export default TabBar;
